import { SongViewWithOrg } from '../../../common/src/model.ts';
import * as server_api from '../../../common/src/server_api.ts';
import { localStorageGet, LocalStorageKey, localStorageRemove, localStorageSet } from './client_local_storage.ts';

class SongViews {
  add(songView: SongViewWithOrg) {
    const cachedSongViews = localStorageGet(LocalStorageKey.SongViews);
    cachedSongViews.push(songView);
    localStorageSet(LocalStorageKey.SongViews, cachedSongViews);
  }

  // Never rejects: callers fire and forget (the player records views on a poll and on unmount), so
  // a failed upload (offline, or no server at all as in Storybook) is logged and the cached song
  // views stay put for the next upload, rather than surfacing as an unhandled rejection.
  async uploadToServer(): Promise<void> {
    const household = localStorageGet(LocalStorageKey.Household);
    const cachedSongViews = localStorageGet(LocalStorageKey.SongViews);
    if (cachedSongViews.length === 0) {
      return;
    }
    try {
      await server_api.reportSongViews(household?.token, cachedSongViews);
    } catch (error: any) {
      console.error(`Failed to upload song views, will retry: ${error.message}`);
      return;
    }
    localStorageRemove(LocalStorageKey.SongViews);
  }
}

export const songViews = new SongViews();
